import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Prevent CRA dev overlay from crashing the app on handled API failures
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { isAxiosError?: boolean; name?: string; response?: { status?: number } };
  if (reason?.isAxiosError || reason?.name === 'AxiosError') {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
